export default __webpack_public_path__ + "static/media/6-saude.4121fcd0.svg";